/**
 * webpackを利用していてモジュール扱いとなるため、
 * windowを経由することでグローバルとして呼び出し可能となる
 */

/**
 * Submit：実行
 */
var lastSubmitTime = "";
var diff = 10; // 初回送信のため初期値10に
window.oh_submit = function (url) {

	var submitTime = new Date();
	if(lastSubmitTime){
		diff = lastSubmitTime.getTime() - submitTime.getTime();
		diff = Math.abs((lastSubmitTime.getTime() - submitTime.getTime())/1000);
	}
	lastSubmitTime = submitTime;

	// 多重クリック対策：前回から10秒以上経過していればsubmitする
	if(diff >= 10) {
		$("#form").attr("action",url);
		$("#form").submit();
	}

}

$(function(){
	// 処理順序１
});

let TOOLS = TOOLS || {};
TOOLS = {
	displayMode: null,
	currentBodyScrollPosition: {top: 0, left: 0},

	init: function() {
		var self = this;

		// 問い合わせ・フォーム系
		self.CONTACT.init();
	},
};

/**
 * 問い合わせ・フォーム系
 */
TOOLS.CONTACT = {

	init: function() {
	  var self = this;

	  // datepicker
	  self.datepicker();

	  // 住所自動入力
	  self.addressAutoFill();

	  // テキストエリア文字数カウント
	  self.charCount();

    // 画面遷移時のアラート表示
	  self.beforeUnLoad();

    // 物件所在地のプルダウン初期表示時の制御
    self.initAddressPulldown();

	},

  /**
	 * 画面遷移時のアラート表示
	 */
	beforeUnLoad: function() {
		$(window).on('beforeunload', function(e) {
      e.preventDefault();
      return '';
    });

    // ボタン押下での画面遷移はアラート表示しない
    $("button").click(function() {
      $(window).off('beforeunload');
    });

	},

	/**
	 * テキストエリア文字数カウント
	 * 使用箇所に「class="js-char-count"」を
	 * 残り文字数表示箇所に「class="js-char-left"」つける
	 */
	charCount: function() {
		$('.js-char-count').on('keyup',function() {
      var val = $(this).val();
      var length = val.replace(/(?:\r\n|\n\r|\r|\n)/g, '\r\n').length;
      var $counter = $(this).next().find('.js-char-left');
      if ($counter.length) {
        $counter.text( $(this).attr('maxlength') - length );
      }
		});
		$('.js-char-count').trigger('keyup');
	},

	/**
	 * テキストエリア文字数カウント2
	 * 使用箇所に「class="js-char-count2"」を
	 * 残り文字数表示箇所に「class="js-char-left2"」つける
	 */
   charCount2: function() {
		$('.js-char-count2').on('keyup',function() {
			if ($(this)[0]) {
				var val = $(this).val();
				$('.js-char-left2').text( $(this).attr('maxlength') - val.replace(/(?:\r\n|\n\r|\r|\n)/g, '\r\n').length );
			}
		});
    $('.js-char-count2').trigger('keyup');
	},

	/**
	 * datepicker
	 * 使用箇所に「class="js-datepicker"」をつける
	 */
	datepicker: function() {
		var datepicker = $('.js-datepicker');

    var isFunc = $.isFunction(datepicker.pickadate);
    if (isFunc) {
      datepicker.pickadate({
        format: "yyyy/mm/dd",
        min: 0,
      });

      // 入力値の引継ぎ
      for(key in datepicker){
        if( datepicker.hasOwnProperty(key) ) {
          var element = datepicker[key];
          var elementId = element.id;

          if(elementId != null){
            var picker = $('#'+ elementId).pickadate().pickadate('picker');
            var data = $('#'+ elementId).data('val');
            if(data != null && data != ""){
              picker.set('select', data);
            }
          }
        }
      }
    }
	},

	/**
	 * 住所自動入力
	 * 使用箇所に「lass="js-address-auto-fill" data-target="住所をいれるところのid"」をつける
	 */
	 addressAutoFill: function() {
		var self = this;
		$(".js-address-auto-fill").on('blur', function() {
			var zip_cd = $(this).val();
			var target = $(this).data('target');
			var regex = new RegExp('^[0-9]{3}-?[0-9]{4}$');

			if (regex.test(zip_cd) ) {
				self.addressAutoFillAjax(zip_cd, target);
			}
		});
	},

	/**
	 * 住所自動入力(Controllerのメソッドを使用)
	 */
	 addressAutoFillAjax: function(zip_cd, target) {
		data = { postNumber : zip_cd };
		$.ajax({
			mode: "abort",
			type : "get",
			url : '/Api/get-address',
			data : data,
			dataType : 'json',
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},

			success : function(params) {
				if ( Object.keys(params).length > 0 ) {
					$("#" + target).val(params['address']);
					// require_address(); // バックカラー制御
				} else {
					alert("住所を取得できませんでした。")
				}
			}
		});
	},

  /**
   * 物件所在地のプルダウン初期表示時の制御
   */
  initAddressPulldown: function() {
    var self = this;

    if($('.js-address-pulldown').length) {
      $('.js-prefecture').on('change', function() {
        let url = $(this).attr('data-api-url');
        self.getCityList(url);
      });

      $('.js-city').on('change', function() {
        let url = $(this).attr('data-api-url');
        self.getTownList(url);
      });

      $('.js-town, .js-etc').on('change', function() {

        let url = $(this).attr('data-api-url');
        self.getOfficeInfo(url);
      });

      // 物件種別が変更された場合、担当営業所の再取得
      $("[id^=valuation_property_type1_]").on('click',function() {
        let url = $('.js-town').attr('data-api-url');
        self.getOfficeInfo(url);
      });

      // 初期値を取得
      pref = $(".js-prefecture").val();
      city = $(".js-city").val();
      town = $(".js-town").val();
      etc = $(".js-etc").val();

      // プルダウンのリストを取得し初期値を選択状態に
      if(pref) {
        let url = $(".js-prefecture").attr('data-api-url');
        self.getCityList(url, city)
          .then(function() {
            if(city) {
              let url = $(".js-city").attr('data-api-url');
              self.getTownList(url, town)
                .then(function() {
                  if(town || etc) {
                    let url = $(".js-town").attr('data-api-url');
                    self.getOfficeInfo(url);
                  }
                });
            }
          });
      }
    }
  },

  /**
   * 物件所在地（市区町村）のプルダウン
   * ・データの取得
   * ・プルダウンを作成
   */
  getCityList: function(url, city) {
    var self = this;
    var defer = $.Deferred();

		data = {};
    data["pref"] = $(".js-prefecture").val();

    $.ajax(url, {
      type: "post",
      data: data,
      dataType: "json",
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    }).done(function(data) {
      self.settingPulldownCity(data.cityList, city);
      defer.resolve();
    }).fail(function() {
      defer.reject();
    });

    return defer.promise();
	},

  /**
   * 物件所在地（町名）のプルダウン
   * ・データの取得
   * ・プルダウンを作成
   */
  getTownList: function(url, town) {
    var self = this;
    var defer = $.Deferred();

		data = {};
    data["pref"] = $(".js-prefecture").val();
    data["city"] = $(".js-city").val();
    $.ajax(url, {
      type: "post",
      data: data,
      dataType: "json",
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    }).done(function(data) {
      self.settingPulldownTown(data.townList, town);
      defer.resolve();
    }).fail(function() {
      defer.reject();
    });

    return defer.promise();
	},

  /**
   * 担当営業所の取得
   */
   getOfficeInfo: function(url) {
    var self = this;
    var defer = $.Deferred();

		data = {};
    data["pref"] = $(".js-prefecture").val();
    data["city"] = $(".js-city").val();
    data["town"] = $(".js-town").val();
    data["etc"] = $(".js-etc").val();
    data["office"] = '';

    // 土地・戸建ての場合は、担当営業所は「不動産事業部」
    valuation_property_type1_2 = $('#valuation_property_type1_2').prop('checked');
    valuation_property_type1_1 = $('#valuation_property_type1_1').prop('checked');
    if(valuation_property_type1_1 || valuation_property_type1_2) {
      data["office"] = 'tochikodate';
    }

    $.ajax(url, {
      type: "post",
      data: data,
      dataType: "json",
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    }).done(function(data) {
      self.settingOfficeInfo(data.officeInfo);
      defer.resolve();
    }).fail(function() {
      defer.reject();
    });

    return defer.promise();
	},

  settingPulldownCity: function(cityList, selectedCity) {

    // 市区町村リストの中身をクリア（未設定以外）
    $(".js-city option:nth-child(n+2)").remove();

    // 町名リストの中身をクリア（未設定以外）
    $(".js-town option:nth-child(n+2)").remove();
    $(".js-town optgroup:nth-child(n+2)").remove();

    // 担当営業所情報をクリア
    this.settingOfficeInfo(null);

    for (var key in cityList) {
      cityNm = cityList[key].city_nm;
      selected = '';

      if(selectedCity == cityNm) {
        selected = 'selected';
      }

      $('.js-city').append('<option value="' + cityNm + '" ' + selected +'>' + cityNm + '</option>');
    }
  },

  settingPulldownTown: function(townList, selectedTown) {

    // 町名リストの中身をクリア（未設定以外）
    $(".js-town option:nth-child(n+2)").remove();
    $(".js-town optgroup:nth-child(n+2)").remove();

    // 担当営業所情報をクリア
    this.settingOfficeInfo(null);

    for (var key in townList) {
      $('.js-town').append('<optgroup label="' + key + '">' + '</optgroup>');

      for (var key2 in townList[key]) {
        townNm = townList[key][key2].etc1_nm;
        selected = '';
        if(selectedTown == townNm) {
          selected = 'selected';
        }

        $('.js-town').append('<option value="' + townNm + '"' + selected +'>' + townNm + '</option>');
      }
    }
  },

  settingOfficeInfo: function(officeInfo) {

    officeNm = '担当営業所が表示されます';
    businessHour = '-';
    holiday = '-';
    freeCall = '-';
    mailAddress = '';
    if(officeInfo) {
      officeNm = officeInfo['office_nm'];
      businessHour = officeInfo['business_hour_txt'];
      holiday = officeInfo['holiday_txt'];
      freeCall = officeInfo['free_call_no'];
      mailAddress = officeInfo['mail_address'];
    }

    $('.js-office-nm').text(officeNm);
    $('.js-business-hour').text(businessHour);
    $('.js-holiday').text(holiday);
    $('.js-office-free-call-text').text(freeCall);

    $('input[name=office_nm]').val(officeNm);
    $('input[name=office_business_hour]').val(businessHour);
    $('input[name=office_holiday]').val(holiday);
    $('input[name=office_free_call]').val(freeCall);
    $('input[name=office_mail_address]').val(mailAddress);
  },

};
$(function() {
  TOOLS.init();
});
